import Reveal from "./Reveal";

const CHAPTERS = [
    {
        num: "Chapter 01",
        title: "Integrity by design",
        body: "We are a registered UK limited company, accountable for the work we do. Your administration is handled by people who sign their name to it — carefully, confidentially and on the record.",
        img: "https://images.pexels.com/photos/14765841/pexels-photo-14765841.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Modern glass architecture in London",
    },
    {
        num: "Chapter 02",
        title: "Accuracy as a habit",
        body: "In back-office work, small errors compound. We build checking into everything — every entry, every invoice, every diary invitation — so you spend less time correcting and more time building.",
        img: "https://images.pexels.com/photos/7793118/pexels-photo-7793118.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Professionals reviewing charts and documents",
    },
    {
        num: "Chapter 03",
        title: "Built around your workflow",
        body: "We don't ask you to change how you work. We learn your tools, your tone and your priorities first — then slot into them so smoothly it feels like we were always there.",
        img: "https://images.pexels.com/photos/5313176/pexels-photo-5313176.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Professional working with documents in a modern office",
    },
];

const Manifesto = () => (
    <section id="approach" data-testid="manifesto-section" className="relative py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-amber-400">
                    02 — How we think
                </p>
                <h2 className="mt-6 max-w-3xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                    A short manifesto for calmer operations.
                </h2>
            </Reveal>

            <div className="mt-20 space-y-24 lg:space-y-32">
                {CHAPTERS.map((c, i) => (
                    <div
                        key={c.num}
                        data-testid={`manifesto-chapter-0${i + 1}`}
                        className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-20 ${
                            i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                        }`}
                    >
                        <Reveal>
                            <p className="font-mono text-sm uppercase tracking-[0.28em] text-slate-500">
                                {c.num}
                            </p>
                            <h3 className="mt-5 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                                {c.title}
                            </h3>
                            <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400">
                                {c.body}
                            </p>
                            <div className="mt-8 h-px w-24 bg-gradient-to-r from-amber-400 to-transparent" />
                        </Reveal>

                        <Reveal delay={0.1}>
                            <div className="duotone-frame group relative overflow-hidden rounded-2xl border border-white/10">
                                <img
                                    src={c.img}
                                    alt={c.alt}
                                    loading="lazy"
                                    className="duotone-img aspect-[4/3] w-full object-cover"
                                />
                                <div className="absolute inset-0 bg-electric/25 mix-blend-color" />
                                <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent" />
                                <span className="absolute left-4 top-4 h-5 w-5 border-l-2 border-t-2 border-amber-400" />
                                <span className="absolute bottom-4 right-4 h-5 w-5 border-b-2 border-r-2 border-amber-400" />
                            </div>
                        </Reveal>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Manifesto;
